export enum CashBackSource {
  Admin = 1,
  Invoice = 2,
}

export enum CashBackStatus {
  Inactive = 1,
  Active = 2,
  RequestToWithdrawal = 3,
  Paid = 4,
  Expired = 5,
  Consumed = 6,
}

export interface ICashBackCard {
  guid: string;
  amount: number;
  reserved_amount: number;
  used_amount: number;
  source: CashBackSource;
  status: CashBackStatus;
}
